import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";

import { APP_ROUTES, toAppChildPath, toRouterPath } from "./constants/appRoutes";
import { AuthModalProvider } from "./context/AuthModalContext";
import { LogoutPromptProvider } from "./context/LogoutPromptContext";
import Root from "./components/Root";
import Dashboard from "./components/dashboard/Dashboard";
import Details from "./components/campaign/Details";
import MyCampaigns from "./components/campaign/List";
import MyPosts from "./components/post/List";
import Wizard from "./components/campaign/wizard/Wizard";
import ActivateAccount from "./components/ActivateAccount";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AccountLocked from "./components/AccountLocked";
import Profile from "./components/Profile";
import Settings from "./components/Settings";
import Plans from "./components/plans/Plans";
import ContentIntelligence from "./components/opportunity/List";
import PaymentSuccess from "./components/payment/PaymentSuccess";
import PaymentFailed from "./components/payment/PaymentFailed";
import PaymentsList from "./components/payment/List";
import ProfileCreateWizard from "./components/profile/create/ProfileCreateWizard";
import NotFound from "./components/NotFound";
import NicheLanding from "./components/landing/NicheLanding";
import { NICHE_LANDING_PAGES } from "./constants/nicheLandingPages";

function AuthModalLayout() {
  return (
    <AuthModalProvider>
      <LogoutPromptProvider>
        <Outlet />
      </LogoutPromptProvider>
    </AuthModalProvider>
  );
}

const router = createBrowserRouter([
  {
    element: <AuthModalLayout />,
    children: [
      {
        path: APP_ROUTES.HOME,
        element: <Root />,
        children: [
      { index: true, element: <Dashboard /> },
      ...NICHE_LANDING_PAGES.map((page) => ({
        path: toAppChildPath(page.path),
        element: <NicheLanding />,
      })),
      {
        path: toAppChildPath(APP_ROUTES.CAMPAIGNS),
        element: <Outlet />,
        children: [
          { index: true, element: <MyCampaigns /> },
          { path: ":id", element: <Details /> },
        ],
      },
      { path: toAppChildPath(APP_ROUTES.POSTS), element: <MyPosts /> },
      { path: toAppChildPath(APP_ROUTES.CONTENT_AI), element: <ContentIntelligence /> },
      {
        path: toAppChildPath(APP_ROUTES.OPPORTUNITIES),
        element: <Navigate to={APP_ROUTES.CONTENT_AI} replace />,
      },
      { path: toAppChildPath(APP_ROUTES.CAMPAIGN_WIZARD), element: <Wizard /> },
      {
        path: `${toAppChildPath(APP_ROUTES.CAMPAIGN_WIZARD)}/:campaignId`,
        element: <Wizard />,
      },
      { path: toAppChildPath(APP_ROUTES.PROFILE), element: <Profile /> },
      { path: toAppChildPath(APP_ROUTES.SETTINGS), element: <Settings /> },
      { path: toAppChildPath(APP_ROUTES.PAYMENTS), element: <PaymentsList /> },
    ],
  },
  { path: toRouterPath(APP_ROUTES.PROFILE_CREATE), element: <ProfileCreateWizard /> },
  { path: toRouterPath(APP_ROUTES.ACTIVATE), element: <ActivateAccount /> },
  { path: toRouterPath(APP_ROUTES.FORGOT_PASSWORD), element: <ForgotPassword /> },
  { path: toRouterPath(APP_ROUTES.RESET_PASSWORD), element: <ResetPassword /> },
  { path: toRouterPath(APP_ROUTES.ACCOUNT_LOCKED), element: <AccountLocked /> },
  { path: toRouterPath(APP_ROUTES.PAYMENT_SUCCESS), element: <PaymentSuccess /> },
  { path: toRouterPath(APP_ROUTES.PAYMENT_FAILED), element: <PaymentFailed /> },
  { path: toRouterPath(APP_ROUTES.PLANS), element: <Plans /> },
  { path: toRouterPath(APP_ROUTES.NOT_FOUND), element: <NotFound /> },
  { path: "*", element: <NotFound /> },
    ],
  },
]);

export default router;
